import { render, staticRenderFns } from "./excom.vue?vue&type=template&id=0392ba5c&"
import script from "./excom.vue?vue&type=script&lang=ts&"
export * from "./excom.vue?vue&type=script&lang=ts&"
import style0 from "./excom.vue?vue&type=style&index=0&id=0392ba5c&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports